import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useApi } from "@/lib/api";

export const useMe = () => {
  const api = useApi();
  return useQuery({ queryKey: ["me"], queryFn: () => api.get("/me") });
};

export const useCanEdit = () => useMe().data?.role !== "viewer";
export const VIEW_ONLY_TIP = "View-only access: ask the workspace owner for editor access to change this";

export const TrialBanner = () => {
  const { data } = useMe();
  if (!data || data.plan !== "trial") return null;
  const days = Math.max(0, Math.ceil((new Date(data.trial_ends_at) - new Date()) / 86400000));
  return (
    <div data-testid="trial-banner" className="border-b border-[#2A2A2A] bg-[#00FF9D]/[0.04] px-4 md:px-8 py-2.5 flex items-center justify-between text-sm">
      <span className="text-[#A3A3A3]">{days > 0 ? <><span className="font-mono text-[#00FF9D]">{days}d</span> left in your free trial · no card needed</> : <span data-testid="trial-banner-ended" className="text-[#FFD166]">Your free trial has ended</span>}</span>
      <Link to="/app/billing" data-testid="trial-upgrade-link" className="text-[#00FF9D] hover:underline">Pick a plan</Link>
    </div>
  );
};
